import React, { useEffect, useState, createElement } from 'react';
import { YtJuevesHero } from '../components/YtJuevesHero';
import { YtJuevesBenefits } from '../components/YtJuevesBenefits';
import { YtJuevesResults } from '../components/YtJuevesResults';
import { YtJuevesCTASection } from '../components/YtJuevesCTASection';
import { YtJuevesAuthorBio } from '../components/YtJuevesAuthorBio';
import { YtJuevesFooter } from '../components/YtJuevesFooter';
import { FacebookPixel } from '../components/FacebookPixel';
import { YtJuevesThankYouPage } from '../components/YtJuevesThankYouPage';
import { NotificationToast } from '../components/NotificationToast';
import { trackEvent } from '../utils/analytics';
import { AlertTriangleIcon } from 'lucide-react';
export function YtJuevesPage() {
  const [showThankYou, setShowThankYou] = useState(false);
  // Track page visit on mount
  useEffect(() => {
    trackEvent('page_visit');
  }, []);
  // Load Google Ads gtag.js
  useEffect(() => {
    const gtagScript = document.createElement('script');
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-11106102578';
    gtagScript.async = true;
    document.head.appendChild(gtagScript);
    const gtagInitScript = document.createElement('script');
    gtagInitScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-11106102578');
    `;
    document.head.appendChild(gtagInitScript);
    return () => {
      document.head.removeChild(gtagScript);
      document.head.removeChild(gtagInitScript);
    };
  }, []);
  if (showThankYou) {
    return <YtJuevesThankYouPage data-id="element-1382" />;
  }
  return <div className="flex flex-col min-h-screen w-full bg-gradient-to-b from-gray-900 to-black text-white" data-id="element-1383">
      <FacebookPixel pixelId="754551913878347" data-id="element-1384" />
      <NotificationToast data-id="element-1385" />
      <header className="fixed top-0 left-0 right-0 z-40 w-full px-4 py-2 bg-gray-900 bg-opacity-80 backdrop-blur-lg border-b border-gray-800 h-[88px]" data-id="element-1386">
        <div className="flex flex-col items-center justify-center h-full gap-0.5" data-id="element-1387">
          <div className="w-full max-w-[600px] h-[40px] flex items-center justify-center px-4" data-id="element-1388">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gqSiWiuARq6wcs7g3ZrS3R/TRUSTED_BADGE.png" alt="Trusted by 1000+ Verified Customers" className="w-full h-auto max-h-[40px] object-contain" data-id="element-1389" />
          </div>
          <div className="w-[100px] h-[28px] flex items-center justify-center" data-id="element-1390">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9nsoAdMCr2MakXFCqq5bSP/gb_signature.png" alt="Signature" className="w-full h-auto max-w-[100px]" width="100" height="28" data-id="element-1391" />
          </div>
        </div>
      </header>
      <main className="flex-grow w-full pt-[88px]" data-id="element-1392">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-5xl" data-id="element-1393">
          <div className="py-8 md:py-16 space-y-16 md:space-y-24" data-id="element-1394">
            <YtJuevesHero isPaused={false} setShowThankYou={setShowThankYou} data-id="element-1395" />
            <YtJuevesBenefits data-id="element-1396" />
            <YtJuevesResults data-id="element-1397" />
            <YtJuevesCTASection setShowThankYou={setShowThankYou} data-id="element-1398" />
            <YtJuevesAuthorBio data-id="element-1399" />

            {/* Legal Disclaimer Section */}
            <section className="bg-gray-800 bg-opacity-50 rounded-2xl p-6 md:p-8 lg:p-10 shadow-2xl" data-id="element-1400">
              <div className="flex items-start mb-6" data-id="element-1401">
                <AlertTriangleIcon className="h-6 w-6 md:h-7 md:w-7 text-yellow-500 mr-3 md:mr-4 flex-shrink-0 mt-1" data-id="element-1402" />
                <h2 className="text-xl md:text-2xl font-bold text-yellow-300" data-id="element-1403">
                  Aviso Legal Importante
                </h2>
              </div>
              <div className="space-y-4 text-sm md:text-base text-gray-300 leading-relaxed" data-id="element-1404">
                <p data-id="element-1405">
                  La información compartida en esta masterclass es con fines
                  educativos e informativos. No garantizamos resultados
                  específicos ni ingresos determinados.
                </p>
                <p data-id="element-1406">
                  Cualquier ejemplo de ingresos o resultados es solo ilustrativo
                  y se basa en experiencias personales o de algunos estudiantes.
                </p>
                <p data-id="element-1407">
                  Tus resultados dependerán de múltiples factores, incluyendo tu
                  experiencia, habilidades, esfuerzo, dedicación, situación
                  personal y condiciones de mercado.
                </p>
                <p data-id="element-1408">
                  Toda actividad de negocio conlleva riesgo, y es posible no
                  obtener resultados o incluso tener pérdidas.
                </p>
                <p className="font-semibold text-yellow-300" data-id="element-1409">
                  Al registrarte, aceptas que eres el único responsable de tus
                  decisiones, acciones y resultados.
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>
      <YtJuevesFooter data-id="element-1410" />
    </div>;
}